/**
 * TanStack Query setup — DESIGN.md §13.2.
 *
 * "TanStack Query owns all server state (no Redux)."
 */
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Slate is a live tool on a fast internal network; a short stale time
        // plus SSE invalidation (§15) beats aggressive caching.
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // Never retry a 4xx: the answer will not change, and retrying a 401
          // just delays the redirect to the login screen.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
